import { useTranslation } from '@library/localization'
import { Box, Heading } from '@library/uikit'
import { TitleNameText } from '@library/uikit/src/components/Text/Text'
import { baseColors } from '@library/uikit/src/theme/colors'
import Container from 'components/Layout/Container'
import styled from 'styled-components'
import { FlexGap } from '../../../components/Layout/Flex'

const StyledHero = styled(Box)`
  background-position: top, center;
  background-repeat: no-repeat;
  background-size: auto 100%;
`

const StyledHeading = styled(Heading)`
  font-size: 36px;
  font-weight: bold;

  ${({ theme }) => theme.mediaQueries.md} {
    font-size: 104px;
    font-weight: 200;
  }
`

const Hero = () => {
  const { t } = useTranslation()

  return (
    <Box pt="5%">
      <StyledHero py={['16px', '16px', '32px']}>
        <Container>
          <FlexGap gap="8px" width="100%" flexDirection="column" pl="4px">
            <StyledHeading as="h1">{t('IGO: Initial Gen Offerings')}</StyledHeading>
            <TitleNameText marginLeft="0px" color={baseColors.normal}>
              {t('Buy your first Gen')}
            </TitleNameText>
          </FlexGap>
        </Container>
      </StyledHero>
    </Box>
  )
}

export default Hero
